import { cn } from '@/lib/utils'

/** How many reminders need marking, next to Recurring. Hidden at zero. */
export function NavBadge({ count, className }: { count: number; className?: string }) {
  if (count <= 0) return null
  return (
    <span
      aria-label={`${count} due`}
      className={cn(
        'grid h-5 min-w-5 place-items-center rounded-full bg-[var(--fl-warning-bg)] px-1.5 text-[11px] font-bold tabular-nums text-[var(--fl-warning)]',
        className
      )}
    >
      {count > 9 ? '9+' : count}
    </span>
  )
}
